var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ColumnContent,
    { attrs: { title: _setup.t("Клиники", _setup.options) } },
    _vm._l(_setup.lpuList, function (lpu) {
      return _c(
        "a",
        {
          key: lpu.translit,
          staticClass:
            "d-table text--text link-decoration-none mb-4 text-body-1",
          attrs: {
            "data-qa": "lpu-types-link",
            href: _setup.reverseFullL10N({
              name: "lpu_speciality",
              args: {
                type_lpu_translit: lpu.translit,
                language: _setup.urlLang,
              },
            }),
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.transDynamic(
                  lpu,
                  `name,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }